import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useEffect, useState } from "react";
import { createOrganizationCall } from "api/api";
import Modal from "../../components/modal";
import ImagePicker from "components/imagePicker/image_picker";
import { uploadLogoCall } from "api/api";

const defaultState = {
  logo: null,
  logo_url: "",
  logo_cdn_url: "",
  name: "",
  address: "",
  phone_number: "",
};

export default function CreateOrganization({ open, onClose, reload }) {
  const [state, setState] = useState(defaultState);

  const setFile = (file) => {
    setState({ ...state, logo: file });
  };

  const onCreate = async () => {
    if (!state.logo) {
      return global.showAlert("Validation Errors", "Organization Logo is required", "warning");
    }
    const formData = new FormData();
    formData.append("file", state.logo);

    const fileResponse = await uploadLogoCall(formData);

    const response = await createOrganizationCall({
      logo_url: fileResponse.url,
      name: state.name,
      address: state.address,
      phone_number: state.phone_number,
    });

    if (response) {
      reload();
    }
  };

  useEffect(() => {
    setState(defaultState);
  }, [open]);

  return (
    <Modal
      title={"Create new organization"}
      open={open}
      actions={
        <MDBox display="flex" gap={1} justifyContent="right">
          <MDButton onClick={onCreate} variant="gradient" color="info">
            submit
          </MDButton>
          <MDButton onClick={onClose} variant="gradient" color="error">
            cancel
          </MDButton>
        </MDBox>
      }
    >
      <MDBox component="form" role="form">
        <MDBox mb={2}>
          <ImagePicker
            imageUrl={state.logo_cdn_url}
            setFile={setFile}
            file={state.logo}
            title={"Logo"}
          />
        </MDBox>

        <MDBox mb={2}>
          <MDInput
            type="string"
            label="Name"
            fullWidth
            value={state.name}
            onChange={(event) => {
              setState({ ...state, name: event.target.value });
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="string"
            label="Address"
            fullWidth
            value={state.address}
            onChange={(event) => {
              setState({ ...state, address: event.target.value });
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="string"
            label="Phone number"
            fullWidth
            value={state.phone_number}
            onChange={(event) => {
              setState({ ...state, phone_number: event.target.value });
            }}
          />
        </MDBox>
      </MDBox>
    </Modal>
  );
}
